const googleSnippet = {
  ofertaPersonales: {
    enable: "https://www.googletagmanager.com/gtag/js?id=AW-879298608",
    init: "AW-879298608",
    consulta: "AW-879298608/mM62CITNiI8YELCQpKMD",
    cliente: "AW-879298608/4_pXCOPhoZ8YELCQpKMD",
    noCliente: "AW-879298608/vK3DCIfNiI8YELCQpKMD",
    landingQR: "AW-879298608/_tvyCIrNiI8YELCQpKMD",
    paso1: "AW-879298608/nhaJCJDNiI8YELCQpKMD",
    paso2: "AW-879298608/bytXCJPNiI8YELCQpKMD",
    paso3: "AW-879298608/Tg7cCJbNiI8YELCQpKMD",
    continuaSucursal: "AW-879298608/jA_mCJnNiI8YELCQpKMD",
    paso4: "AW-879298608/Fo2yCI3NiI8YELCQpKMD",
    loadingVeridas: false,
    biometriaOK: false,
    solicita: "AW-879298608/KTwrCJzNiI8YELCQpKMD",
    entrega: "AW-879298608/nVvDCJ_NiI8YELCQpKMD",
    resumen: "AW-879298608/RY_8CKLNiI8YELCQpKMD",
    contratos: "AW-879298608/VigFCKXNiI8YELCQpKMD",
    gracias: "AW-879298608/zDbuCKjNiI8YELCQpKMD",
    usuario: "AW-879298608/7frfCKvNiI8YELCQpKMD",
    celular: "AW-879298608/-tmqCK7NiI8YELCQpKMD",
    final: "AW-879298608/Y1YaCKzOiI8YELCQpKMD",
    mensaje: "AW-879298608/01e3CK_UneYYELCQpKMD"
  },
  ofertaPrestamosEmprendedores: {
    enable: "https://www.googletagmanager.com/gtag/js?id=AW-685925423",
    init: "AW-685925423",
    consulta: "AW-685925423/HQeRCMTbv6oZEK_IiccC",
    oferta: "AW-685925423/zm0qCMD_waoZEK_IiccC",
    landingQR: "AW-685925423/6FsyCNTDvaoZEK_IiccC",
    paso1: "AW-685925423/FrcdCJ-Mw6oZEK_IiccC",
    paso2: "AW-685925423/xC8ECNLfvaoZEK_IiccC",
    paso3: "AW-685925423/D3yuCOGXpasZEK_IiccC",
    continuaSucursal: "AW-685925423/X_CSCOCwn6sZEK_IiccC",
    paso4: "AW-685925423/PV5OCM7WoqsZEK_IiccC",
    loadingVeridas: "AW-685925423/czqtCKrloqsZEK_IiccC",
    biometriaOK: "AW-685925423/oD47CLjnoqsZEK_IiccC",
    solicita: false,
    entrega: "AW-685925423/TjfjCNKvpasZEK_IiccC",
    resumen: "AW-685925423/4kTYCOL2oqsZEK_IiccC",
    contratos: "AW-685925423/dVMKCNv4oqsZEK_IiccC",
    gracias: "AW-685925423/N7qDCPTZn6sZEK_IiccC",
    usuario: "AW-685925423/0_5vCK2Do6sZEK_IiccC",
    celular: "AW-685925423/eKJBCMTfn6sZEK_IiccC",
    final: false,
    mensaje: false
  },
  ofertaHipotecarios: {
    enable: false,
    init: false,
    consulta: false
  }
};

const facebookSnippet = {
  ofertaPersonales: {
    consulta: ["track", "ViewContent", "PP No clientes"],
    cliente: ["track", "Search", "Prestamo Pre Aprobado"],
    noCliente: ["track", "ViewContent", "PP No clientes", "PP No clientes"],
    landingQR: ["track", "Search", "PP No clientes", "PP No clientes"],
    paso1: [
      "track",
      "CompleteRegistration",
      "PP No clientes",
      "PP No clientes"
    ],
    paso2: ["track", "AddToCart", "PP No clientes"],
    paso3: ["track", "AddPaymentInfo", "PP No clientes"],
    continuaSucursal: ["track", "Search", "PP No clientes"],
    paso4: ["track", "CompleteRegistration", "PP No clientes"],
    loadingVeridas: [false],
    biometriaOK: [false],
    solicita: ["track", "AddToWishlist", "PP No clientes"],
    entrega: ["track", "InitiateCheckout", "PP No clientes"],
    resumen: ["track", "Lead", "PP No clientes"],
    contratos: ["track", "AddPaymentInfo", "PP No clientes", "PP No clientes"],
    gracias: ["track", "Purchase", "PP No clientes"],
    usuario: ["track", "ViewContent", "PP No clientes Banca Virtual"],
    celular: ["track", "AddToCart", "PP No clientes Banca Virtual"],
    final: ["track", "Lead", "PP No clientes Banca Virtual"],
    mensaje: ["track", "Lead", "PP No clientes", "credito no aprobado"]
  },
  ofertaPrestamosEmprendedores: {
    consulta: ["track", "ViewContent", "Empresa"],
    oferta: ["track", "Lead", "Empresa"],
    landingQR: ["track", "Search", "Empresa", "nocliente"],
    paso1: ["trackCustom", "Terms", "Empresa", "Empresa"],
    paso2: ["track", "CompleteRegistration", "Empresa", "Datoslaborales"],
    paso3: ["trackCustom", "Suscribe - eleccion", "Empresa", "informacion"],
    continuaSucursal: ["track", "AddPaymentInfo", "Empresa", "Adicional"],
    paso4: ["track", "AddToWishlist", "Empresa", "Identidad"],
    loadingVeridas: ["track", "Subscribe", "Empresa", "Validandofoto"],
    biometriaOK: ["track", "AddToCart", "Empresa", "Felicitaciones"],
    solicita: [false],
    entrega: ["trackCustom", "Suscribe - Opciones", "Empresa", "resumen"],
    resumen: ["trackCustom", "Landing", "Empresa"],
    contratos: ["trackCustom", "ClientePotencial", "Empresa", "Contratos"],
    gracias: ["track", "Purchase", "Empresa"],
    usuario: ["track", "InitiateCheckout", "Empresa", "usuario"],
    celular: ["trackCustom", "ErrorProceso", "Empresa", "validacelular"],
    final: [false],
    mensaje: [false]
  },
  ofertaHipotecarios: {
    consulta: [false],
    mensaje: [false]
  }
};

export { googleSnippet, facebookSnippet };
